import React from 'react';

import { ComponentBase } from '../../../shared/ComponentBase.js';
import { InjectedStyledComponent } from '../../../shared/InjectedStyledComponent.js';

import { IMenuItemConfiguration, IMenuItemProps, IMenuItemState } from './models/index.js';
import { TMenuItemType } from './models/TMenuItemType.js';
import { menuItemStyle } from './styles/MenuItem.style.js';
import { MENU_ITEM_CATEGORY_KEY, MENU_ITEM_COMPONENT_KEY } from './MenuItem.meta.js';

export class MenuItem extends ComponentBase<IMenuItemProps, IMenuItemState, IMenuItemConfiguration> {
	categoryKey = MENU_ITEM_CATEGORY_KEY;
	componentKey = MENU_ITEM_COMPONENT_KEY;
	ref = React.createRef<HTMLLIElement>();

	constructor(props: IMenuItemProps) {
		super(props);
	}

	componentDidMount() {
		this.applyFocus();
	}

	componentDidUpdate() {
		this.applyFocus();
	}

	applyFocus() {
		if (this.props.hasFocus && this.ref?.current?.focus) {
			this.ref.current.focus();
		}
	}

	applyRole(type: TMenuItemType) {
		switch (type) {
			case 'checkbox':
				return 'menuitemcheckbox';
			case 'radio':
				return 'menuitemradio';
			case 'standard':
			default:
				return 'menuitem';
		}
	}

	applyChecked(type: TMenuItemType, isSelected: boolean): boolean | undefined {
		switch (type) {
			case 'checkbox':
			case 'radio':
				return isSelected;
			case 'standard':
			default:
				return undefined;
		}
	}

	applyClassName(isSelected: boolean) {
		const additionalClassNames = [];
		if (isSelected) {
			additionalClassNames.push('selected');
		}
		return this.appendClassNames(additionalClassNames);
	}

	render() {
		const {
			children,
			type = 'standard',
			hasFocus = false,
			isSelected = false,
			onClick,
			onKeyDown,
			...props
		} = this.componentProps;

		return (
			<li
				{...props}
				ref={this.ref}
				role={this.applyRole(type)}
				aria-checked={this.applyChecked(type, isSelected)}
				className={this.applyClassName(isSelected)}
				data-selector={this.selector}
				onClick={onClick}
				onKeyDown={onKeyDown}
				tabIndex={-1}
			>
				{children}
			</li>
		);
	}
}

export default InjectedStyledComponent(
	MenuItem,
	MENU_ITEM_CATEGORY_KEY,
	MENU_ITEM_COMPONENT_KEY,
	undefined,
	undefined,
	undefined,
	menuItemStyle,
);
